import DataTable from "./DataTable";
import { HeadCell, DataTableCell } from "./dataTable.interface";

export type { HeadCell, DataTableCell };

export default DataTable;